export default function centsToEuro(cents) {
  return (Math.round(+cents * 100) / 100 / 100).toFixed(2)
}
